import { FREE_MOCK_FORM } from '../constants/mockForms';
import { L2_FREE_MOCK_FORM } from '../constants/mockFormsL2';
import { L3_FREE_MOCK_FORM } from '../constants/mockFormsL3';
import { levelHasFreeMock, normalizeLevel } from '../constants/levels';
import {
  FREE_SESSION_KEY,
  FREE_SESSION_KEY_L2,
  FREE_SESSION_KEY_L3,
  FREE_TRIAL_KEY,
  FREE_TRIAL_QUESTIONS,
} from '../constants/pricing';

/** LocalStorage + profile field names for the complimentary mock per level. */
export function freeMockKeys(level = 'l1') {
  const lv = normalizeLevel(level);
  if (lv === 'l2') {
    return {
      level: 'l2',
      formId: L2_FREE_MOCK_FORM,
      usedField: 'freeSessionUsedL2',
      completedAtField: 'freeMockCompletedAtL2',
      localKey: FREE_SESSION_KEY_L2,
    };
  }
  if (lv === 'l3') {
    return {
      level: 'l3',
      formId: L3_FREE_MOCK_FORM,
      usedField: 'freeSessionUsedL3',
      completedAtField: 'freeMockCompletedAtL3',
      localKey: FREE_SESSION_KEY_L3,
    };
  }
  return {
    level: 'l1',
    formId: FREE_MOCK_FORM,
    usedField: 'freeSessionUsed',
    completedAtField: 'freeMockCompletedAt',
    localKey: FREE_SESSION_KEY,
  };
}

export function freeMockFormId(level = 'l1') {
  return freeMockKeys(level).formId;
}

export function isComplimentaryMockForm(level, mockFormId) {
  if (!levelHasFreeMock(level)) return false;
  const formId = freeMockFormId(level);
  return formId != null && Number(mockFormId) === Number(formId);
}

function localFlag(key) {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function localLegacyL1Exhausted() {
  try {
    const n = parseInt(window.localStorage.getItem(FREE_TRIAL_KEY) || '0', 10);
    return Number.isFinite(n) && n >= FREE_TRIAL_QUESTIONS;
  } catch {
    return false;
  }
}

/** Device-only: complimentary mock already completed for this level. */
export function getLocalFreeMockUsedForLevel(level = 'l1') {
  const { localKey, level: lv } = freeMockKeys(level);
  if (localFlag(localKey)) return true;
  if (lv === 'l1') return localLegacyL1Exhausted();
  return false;
}

/**
 * Profile + device: complimentary mock used for `level`.
 * Signed-in users trust profile flags only (device can be wiped).
 */
export function hasUsedFreeMockForLevel(level, profile = {}, user = null) {
  const keys = freeMockKeys(level);
  const used = Boolean(profile?.[keys.usedField] || profile?.[keys.completedAtField]);
  if (user) return used;
  if (used) return true;
  return getLocalFreeMockUsedForLevel(level);
}

/** Pick freeUsed from access object for a quiz level. */
export function freeUsedFromAccess(access, level = 'l1') {
  const lv = normalizeLevel(level);
  if (lv === 'l2') return Boolean(access?.freeUsedL2);
  if (lv === 'l3') return Boolean(access?.freeUsedL3);
  return Boolean(access?.freeUsed);
}
